module.exports = __webpack_public_path__ + "static/media/suncreation-logo.7211163a.png";